import React from 'react'
import { Menu, Image } from 'semantic-ui-react'

import "./index.scss";
import Logo from "../../images/logo.png";

function HeaderControl({ context }) {
  return (
    context.authenticated ?
    <div class="header">
      <Menu borderless fixed="top">
        <Menu.Item>
          <a href="/">
              <Image src={Logo} className="mdBrand" />
          </a>
        </Menu.Item>
      </Menu>
    </div>
    : null
  )
}

export default HeaderControl
